import { useContext } from 'react'
import { ThemeContext } from './contexts/theme'
import { Route } from 'react-router-dom'
import { Routes } from 'react-router-dom'
import GoogleAnalyticsProvider from './providers/GoogleAnalyticsProvider'
import NotFound from './components/NotFound/NotFound'
import Header from './components/Header/Header'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import Footer from './components/Footer/Footer'
import Home from './components/Home/Home'
import './App.scss'

const App: React.FC = () => {
  const { themeName } = useContext(ThemeContext)

  return (
    <GoogleAnalyticsProvider>
      <div id='top' className={`${themeName} app`}>
        <Header />
        <Routes>
          <Route path='*' element={<NotFound />} />
          <Route
            path="/"
            element={<Home />}
          />
        </Routes>
        <ScrollToTop />
        <Footer />
      </div>
    </GoogleAnalyticsProvider>
  )
}

export default App
